const API_BASE = (process.env.REACT_APP_BASE_URL || window.location.origin).replace(/\/+$/, '');
const BASE = `${API_BASE}/leave`;

const getAuthHeaders = () => {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token') || '';
     return {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
     };
};

async function request(path, opts = {}) {
     const url = `${BASE}${path}`;
     const res = await fetch(url, opts);
     const text = await res.text();
     let json = null;
     try { json = text ? JSON.parse(text) : null; } catch (e) { /* non-json response */ }
     if (!res.ok) {
          const err = new Error(json?.message || `Request failed: ${res.status}`);
          err.status = res.status;
          err.payload = json;
          throw err;
     }
     return json;
}

export function applyLeave(payload) {
     return request('/apply', {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify(payload)
     });
}

export function approveLeave(leaveId, payload = {}) {
     return request(`/approve/${leaveId}`, {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify(payload)
     });
}

export function rejectLeave(leaveId, payload = {}) {
     return request(`/reject/${leaveId}`, {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify(payload)
     });
}

export function pullBackLeave(leaveId) {
     return request(`/pullBack/${leaveId}`, {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify({})
     });
}

export function getMyLeaves(param = 'me') {
     return request(`/myLeaves/${encodeURIComponent(param)}`, {
          method: 'GET',
          headers: getAuthHeaders()
     });
}

export function getPendingLeaves() {
     return request('/pending', {
          method: 'GET',
          headers: getAuthHeaders()
     });
}

export function updateLeave(leaveId, payload) {
     // CHANGE the path to match your backend (example shown uses /update/:id)
     return request(`/update/${encodeURIComponent(leaveId)}`, {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify(payload)
     });
}